import { IconProps } from '@velocity-exchange/icons';
import { cj } from 'src/utils/classNames';
import { getColorVar } from 'src/utils/theme/colorVars';

export default function HamburgerWithDot({
	size = 16,
	className,
	color,
	...props
}: IconProps) {
	return (
		<span className={cj('inline-flex', className)} {...props}>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width={size}
				height={size}
				fill="none"
				viewBox="0 0 24 24"
			>
				<path
					fill={color ?? 'currentColor'}
					d="M20 17.25a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1 0-1.5zm-5.271-6c.814.476 1.76.75 2.771.75.986 0 1.911-.261 2.712-.716A.747.747 0 0 1 20 12.75H4a.75.75 0 0 1 0-1.5zm-2.585-6a5.5 5.5 0 0 0-.138 1.5H4a.75.75 0 0 1 0-1.5z"
				/>
				<path
					fill={getColorVar('negative-red')}
					d="M17.5 11a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9"
				/>
			</svg>
		</span>
	);
}
